export default {
  endpoint: process.env.VUE_APP_API_BASE_URL,
  public: {
    "Content-Type": "application/json",
    "app-id": process.env.VUE_APP_ID,
    "app-secret": process.env.VUE_APP_SECRET
  }
};
